import React, { useReducer } from 'react';
import { CurrentUser } from '@Models/CurrentUser';

//Potentially all obsolete
type State = {
    loggedIn?: CurrentUser;
    pendingAuthAction: 'cognito-confirm-registration' | undefined; //This is to give the registration process a bit of memory
};

export type IncomingUserContextAction = {
    type: string;
    user?: CurrentUser
}
export enum IncomingUserContextActionType {
    LoggedIn = "LOGGED_IN",
    CognitoRegistrationSubmitted = "COGNITO_REGISTRATION_SUBMITTED",
}

const emptyState: State = {
    pendingAuthAction: undefined
}

type ContextType = State & {
    dispatch: React.Dispatch<IncomingUserContextAction>
};

export const IncomingUserContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: IncomingUserContextAction): State {
    switch (action.type) {
        case IncomingUserContextActionType.LoggedIn:
            return {
                loggedIn: action.user,
                pendingAuthAction: undefined
            };
        case IncomingUserContextActionType.CognitoRegistrationSubmitted:
            return {
                ...state,
                pendingAuthAction: 'cognito-confirm-registration'
            };
        default:
            return state;
    }
}

// "Argument of type 'State' is not assignable to parameter of type 'never'.ts(2345)"
// this error means the reducer isn't always returning a state obvject
export function IncomingUserContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);

    const value = { ...state, dispatch };
    return <IncomingUserContext.Provider value={value}>{props.children}</IncomingUserContext.Provider>;
}
